<template lang="pug">
  .b-node__block
    .b-select-outer
      v-select.v-select(
        v-model="item.text"
        :options="options"
        :reduce="o => o.code"
        @input="_updateNode"
        :clearable="false"
        appendToBody
      )
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';

export default {
  name: 'NodeSelect',
  props: {
    item: Object,
  },
  data() {
    return {
      options: [
        {
          label: 'English',
          code: 'en',
        },
        {
          label: 'Russian',
          code: 'ru',
        },
        {
          label: 'Ukrainian',
          code: 'ukr',
        },
      ],
    };
  },
  computed: {
    ...mapFields('nodes', [
      'date',
      'draggingItem',
      'dropType',
    ]),
  },
  methods: {
    ...mapActions('nodes', [
      'updateNode',
    ]),
    _updateNode(value) {
      this.updateNode({
        node: {
          ...this.item,
          text: value,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
@import "@/styles/variables/variables";

.vs__dropdown-toggle {
  padding: 5px 0;
  border: $border;
  border-radius: 0;

  .vs--open & {
    border-color: $color_bgHover;
  }
}

.vs__dropdown-option {
  font-size: 12px;
  line-height: 1;
  text-align: left;
  padding: 4px 8px 5px;
  transition: all 0.3s;
  cursor: pointer;
}
.vs__dropdown-option--highlight {
  color: #fff;
  background: #ED6661;
}
.vs__open-indicator {
  fill: #ED6661;
}
</style>
